Ext.define('SA.view.menu.AddRemoveFavoriteLocation', {
    alias: 'widget.menu-add-remove-favorite-location',
    extend: 'Ext.menu.Item',

    beforeMenuShow() {
        this.refresh();
    },

    getLocation() {
        return this.location;
    },

    handler() {
        SA.data.FavoriteLocations[this.isFavorite() ? 'remove' : 'add'](this.getLocation());
    },

    isFavorite() {
        return SA.data.FavoriteLocations.contains(this.getLocation());
    },

    refresh() {
        var text = this.isFavorite() ? 'Remove from Favorites' : 'Add to Favorites';

        this.setText(SA.localize(text));
    }
});